<template>
	<div class="logo">
		<Fade>
			<img :src="logostore.current_logo" class="logo" :key="logostore.current_logo"/>
		</Fade>
	</div>
</template>

<script setup>
import { useLogoStore } from "@/stores/logostore";
import Fade from "./components/Transitions/Fade.vue";
const logostore = useLogoStore();

</script>
